import React from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import { Observer } from 'mobx-react-lite';
import { Field, Form } from 'formik';
import ParadigmButton from '../../../../material/button';
import ParadigmInput from '../../../../material/input';
import entitiesContext from '../../../../stores/entities-store';
import { ModalActionsWrapper } from '../../../../material/modal';

const EditKeysForm = ({ isSubmitting, onClose, dirty, apiKey }) => {
  const entitiesStore = React.useContext(entitiesContext);

  return (
    <Observer>
      {() => (
        <Form noValidate>
          <Field
            name="name"
            label="Name"
            component={ParadigmInput}
            required
            autoFocus
          />
          <Field
            name="entity"
            label="Entity"
            component={ParadigmInput}
            select
            required
          >
            {entitiesStore.entitiesEnabledArray.map((entity) => (
              <MenuItem key={entity.id} value={entity}>
                {entity.name}
              </MenuItem>
            ))}
          </Field>
          <Field
            name="account_address"
            label="Account Address"
            component={ParadigmInput}
            placeholder="0x..."
          />
          <Field
            name="subkey"
            label="Trading Key (private)"
            component={ParadigmInput}
            placeholder="0x..."
          />
          <div
            style={{
              fontSize: '0.75rem',
              color: '#aaa',
              marginTop: '-8px',
              marginBottom: '8px',
            }}
          >
            Must be a trading key private key, not your account key.{' '}
            <a
              href="https://docs.paradex.trade/api/general-information/api-authentication#subkeys"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: '#f5c542' }}
            >
              How to generate a trading key ↗
            </a>
          </div>
          <ModalActionsWrapper>
            <ParadigmButton secondary text="Cancel" onClick={onClose} />
            <ParadigmButton
              type="submit"
              busy={isSubmitting}
              disabled={!dirty}
              text="Save"
            />
          </ModalActionsWrapper>
        </Form>
      )}
    </Observer>
  );
};

export default EditKeysForm;
